import { Mobile } from '@bimser/common';
import SelectionList from '../components';
import { createGuid } from '@bimser/core';
import { findMessage } from '@bimser/components';

export function setFunctionsForMobile(this: SelectionList) {
	Mobile.MobileView.setFunctionForMobile(
		Mobile.MobileFunctions.OnSelectedChangedSelectionForm,
		(rows: any) => {
			const rowValue = Mobile.MobileView.isAndroidAvaliable
				? rows.replaceAll('\n', '\\n')
				: rows;

			const selectedRows = JSON.parse(rowValue);

			this.bcDataGridRef.current.instance().selectRows(
				selectedRows.map(row => row[this.valueExpr]),
				false
			);

			const selectedIds = selectedRows.map(selectedRow => selectedRow[this.valueExpr]);

			Mobile.MobileView.mobileClientSideMessages([
				{
					typeName: 'ShowMessageAction',
					dialogType: 'Summary',
					alertType: 'Info',
					id: createGuid(),
					messages: selectedIds.length
						? selectedIds.toString()
						: findMessage.get('101967'),
					name: findMessage.get('100647'),
					enabled: true
				}
			]);
		}
	);

	Mobile.MobileView.setFunctionForMobile(Mobile.MobileFunctions.BtnOkClickedSelectionForm, () =>
		this.btnOkClicked()
	);
}
